exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[data-v-35b783f8] input,[data-v-35b783f8] textarea{width:100%;border:0;padding:0;resize:none}.disabled[data-v-35b783f8]{pointer-events:none}.transparent[data-v-35b783f8] input{background-color:transparent;border:0;color:#ffffff}\n", ""]);

